import { CSSProperties, FC } from 'react';
import { styled } from '@mui/material';
import { TEXT } from '../../Helpers/colors';

type TextType = 'lg' | 'sm' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'plg' | 'pmd' | 'psm' | 'pxs';
type FontType = 'main' | 'header';
type FontWeightType = 'regular' | 'medium' | 'semiBold' | 'bold';

const fontSizes = {
	lg: '56px',
	sm: '48px',
	h1: '40px',
	h2: '36px',
	h3: '32px',
	h4: '28px',
	h5: '24px',
	h6: '20px',
	plg: '18px',
	pmd: '16px',
	psm: '14px',
	pxs: '12px',
};

const lineHeights = {
	lg: '64px',
	sm: '56px',
	h1: '48px',
	h2: '44px',
	h3: '40px',
	h4: '36px',
	h5: '32px',
	h6: '28px',
	plg: '28px',
	pmd: '24px',
	psm: '20px',
	pxs: '16px',
};

const fontWeights = {
	regular: 400,
	medium: 500,
	semiBold: 600,
	bold: 700,
};

const fonts = {
	main: 'Inter',
	header: 'Fira Sans',
};

const TextComponent = styled('div')<{
	color: string;
	fontFamily: string;
	fontSize: string;
	fontWeight: number;
	lineHeight: string;
}>(({ fontSize, lineHeight, fontFamily, fontWeight, color }) => ({
	color,
	fontFamily,
	fontSize,
	fontStyle: 'normal',
	fontWeight,
	lineHeight,
}));

interface TextProperties {
	center?: boolean;
	className?: string;
	color?: string;
	font?: FontType;
	fontWeight?: FontWeightType;
	onClick?: () => void;
	style?: CSSProperties;
	title: string | number;
	type?: TextType;
}

const Text: FC<TextProperties> = ({
	type = 'pmd',
	title,
	font = 'main',
	fontWeight = 'regular',
	color = TEXT.PRIMARY,
	className,
	onClick,
	// { wordBreak: "break-word", whiteSpace: "normal" }
	style,
}) => (
	<TextComponent
		onClick={onClick}
		color={color}
		style={style}
		className={className}
		fontSize={fontSizes[type]}
		lineHeight={lineHeights[type]}
		fontFamily={fonts[font]}
		fontWeight={fontWeights[fontWeight]}
	>
		{title}
	</TextComponent>
);

export default Text;
